function buildCookieBase({
  name,
  value,
  maxAgeSeconds,
  expires,
  path = "/",
  sameSite = "Lax",
  secure,
}) {
  const encodedName = encodeURIComponent(name);
  const encodedValue = encodeURIComponent(value);
  const parts = [`${encodedName}=${encodedValue}`];

  if (typeof maxAgeSeconds === "number") parts.push(`Max-Age=${maxAgeSeconds}`);
  if (expires instanceof Date) parts.push(`Expires=${expires.toUTCString()}`);
  if (path) parts.push(`Path=${path}`);
  if (sameSite) parts.push(`SameSite=${sameSite}`);

  // If not explicitly passed, default to Secure when https.
  const shouldSecure =
    typeof secure === "boolean"
      ? secure
      : typeof window !== "undefined" && window.location?.protocol === "https:";
  if (shouldSecure) parts.push("Secure");

  return parts.join("; ");
}

export const DEFAULT_COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60; // 24 hours
export const ADMIN_COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60; // 24 hours

export function setCookie(
  name,
  value,
  {
    maxAgeSeconds,
    maxAgeDays,
    path = "/",
    sameSite = "Lax",
    secure,
  } = {}
) {
  if (typeof document === "undefined") return;

  const computedMaxAgeSeconds =
    typeof maxAgeSeconds === "number"
      ? maxAgeSeconds
      : typeof maxAgeDays === "number"
        ? Math.floor(maxAgeDays * 24 * 60 * 60)
        : DEFAULT_COOKIE_MAX_AGE_SECONDS;
  const expires =
    computedMaxAgeSeconds === 0
      ? new Date(0)
      : new Date(Date.now() + computedMaxAgeSeconds * 1000);

  document.cookie = buildCookieBase({
    name,
    value,
    maxAgeSeconds: computedMaxAgeSeconds,
    expires,
    path,
    sameSite,
    secure,
  });
}

export function getCookie(name) {
  if (typeof document === "undefined") return null;

  const encodedName = encodeURIComponent(name) + "=";
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (const part of parts) {
    if (part.startsWith(encodedName)) {
      return decodeURIComponent(part.slice(encodedName.length));
    }
  }
  return null;
}

export function removeCookie(
  name,
  { path = "/", sameSite = "Lax", secure } = {}
) {
  // Max-Age=0 effectively deletes the cookie.
  setCookie(name, "", { maxAgeSeconds: 0, path, sameSite, secure });
}

